import { useMutation, useQueryClient } from 'react-query'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { axios } from '../../../lib'

const updateUser = (data: any): Promise<any> => {
  return axios.put(`users/${data.userId}`, data)
}

export function useUpdateUser() {
  const queryClient = useQueryClient()
  const navigate = useNavigate()

  return useMutation(updateUser, {
    onSuccess: () => {
      queryClient.invalidateQueries('users')

      toast.success('Usuário atualizado com sucesso!')
      navigate('/users')
    },
    onError: (error: unknown) => {
      console.error(error)
      toast.error('Não foi possível atualizar o usuário!')
    }
  })
}
